import { AppState } from "store";
import { FormTemplatesFiltersArgs } from "./types";

export const formTemplatesFiltersSelector = ({
  filters,
}: AppState): FormTemplatesFiltersArgs => {
  return filters.formTemplates;
};
